module.exports = __webpack_public_path__ + "img/cv.f1509ab5.svg";